export const TABLE_CELL_ALIGN = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};

export const TABLE_CELL_CUSTOM = {
  status: 'labelStatus',
  custom: 'custom',
};

export class Data {
  constructor({
    panelActions = true,
    panelActionsSearch = true,
    select = false,
    onSearch,
    titleMobile,
    searchInput = true,
    advancedFilters = false,
  }) {
    this.headers = [];
    this.actions = [];
    this.fields = [];
    this.onSearch = onSearch;
    this.panelActions = panelActions;
    this.panelActionsSearch = panelActionsSearch;
    this.searchInput = !advancedFilters ? searchInput : false;
    this.advancedFilters = advancedFilters;
    this.select = select;

    if (titleMobile) {
      this.addField({
        key: 'titleMobile',
        customClass: 'table-mobile-title',
        formatter: (currentValue, key, item) => titleMobile(item),
      });
    }

    if (select) {
      this.addField({
        key: 'select',
        customClass: 'table-checkbox',
        width: 80,
      });
    }
  }

  onSearch(value) {
    if (!this.onSearch) {
      console.error('options onSearch not implemented');
      return;
    }
    this.options.onSearch(value);
  }

  getOptions() {
    return {
      panelActions: this.panelActions,
      panelActionsSearch: this.panelActionsSearch,
      select: this.select,
      searchInput: this.searchInput,
      advancedFilters: this.advancedFilters,
    };
  }

  addActions({ name, icon, label, action, groupIndex = 0 }) {
    if (!this.actions[groupIndex]) {
      this.actions[groupIndex] = [];
    }

    this.actions[groupIndex].push({
      name,
      icon,
      label,
      action,
    });
    return this;
  }

  getActions() {
    return this.actions;
  }

  addField({
    key,
    label,
    formatter,
    sortable = false,
    align = TABLE_CELL_ALIGN.left,
    width,
    customClass,
  }) {
    const style = [];
    const classes = [align];

    if (width) {
      style.push(`width: ${width}px`);
    }

    if (customClass) {
      classes.push(customClass);
    }

    this.fields.push({
      key,
      label,
      formatter,
      sortable,
      class: classes.join(' '),
      thStyle: style.join('; '),
    });
    return this;
  }

  getFields() {
    return this.fields;
  }
}
